<template>
  <v-combobox
    v-model="journal"
    v-bind="$attrs"
    :items="journauxDisponibles"
    @update:search-input="updateInputValue"
    item-text="libelle"
    return-object
    :data-testid="dataTestid"
  />
</template>

<script>
import { mapGetters } from "vuex";
import copy from "@/services/copy";
import _ from "lodash";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    value: {
      type: Object,
      required: false,
    },
    initial: {
      type: Object,
      required: false,
    },
    codePostal: {
      type: String,
      required: false,
    },
    extraitpub: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      journal: null,
      libelle: null,
    };
  },

  methods: {
    syncJournal() {
      if (!_.isEqual(this.value?.libelle, this.libelle)) {
        this.libelle = this.value?.libelle;
        this.journal = copy(this.value || null);
      }
    },
    contientJournal(journal) {
      const id = journal.id;
      return !!this.journauxParCodePostal.find(j => j.id === id);
    },
    resoudJournal(journal) {
      return this.journauxDisponibles.find(j => j.libelle === journal);
    },
    updateInputValue(value) {
      this.libelle = value;
    },
    matchDepartement(j) {
      return (
        this.ignoreCodePostal || (this.codePostal || "nop").startsWith(j.departement)
      );
    },
  },

  watch: {
    value() {
      this.syncJournal();
    },
    libelle() {
      const journal = copy(this.libelle || null);
      const resolu = this.resoudJournal(journal);

      const out = resolu ? copy(resolu) : { id: -1, libelle: journal };

      if (!_.isEqual(this.value, out)) {
        this.$emit("input", out);
      }
    },
    ignoreCodePostal() {
      if (!this.ignoreCodePostal && this.value) {
        if (!this.matchDepartement(this.value)) {
          this.libelle = null;
          this.journal = null;
          this.$emit("input", null);
        }
      }
    },
  },

  mounted() {
    this.syncJournal();
  },

  computed: {
    journauxDisponibles() {
      const entete = {
        header: "Sélectionner une valeur, ou saisissez une valeur autre",
      };
      if (this.initial) {
        if (!this.contientJournal(this.initial)) {
          return [entete, this.initial, ...this.journauxParCodePostal];
        }
      }
      return [entete, ...this.journauxParCodePostal];
    },
    ignoreCodePostal() {
      return "PUBFUS" === this.extraitpub;
    },
    journauxParCodePostal() {
      return this.journaux.flatMap(j => {
        if (this.matchDepartement(j)) {
          return [{ id: j.id, libelle: j.libelle, departement: j.departement }];
        }
        return [];
      });
    },
    ...mapGetters({
      journaux: "fichiers/journaux",
    }),
  },
};
</script>
